import { Heading, ScrollList, theme } from '@hhgtech/hhg-components'

import { Container } from 'components/atoms/container'
import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { domainLocales } from 'domainLocales'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { Article } from 'interfaces/types'

import {
  StyledGeneralDesktopContainer,
  StyledHeroContainer,
  StyledArticleContainer,
  StyledArticleDesktopContainer,
  StyledSubHeroContainer,
  StyledTitleContainer,
  StyledScrollListContainer,
} from './index.styled'

export type Props = {
  posts: Article[]
  title: string
}
const GeneralSection = ({ posts, title }: Props) => {
  const { locale } = useRouterExtend()
  const isMobile = useIsMobile()

  return (
    <div data-name={title}>
      {isMobile ? (
        <Container
          style={{
            backgroundColor: theme.colors.white,
            marginTop: 48,
            marginBottom: 24,
          }}
        >
          <StyledTitleContainer>
            <Heading tag="h3">{title}</Heading>
          </StyledTitleContainer>
          <StyledScrollListContainer>
            <ScrollList
              className="gird-view"
              column={1}
              distanceOverlappedLeft={{
                amount: 0,
                unit: 'percentage',
              }}
              isDotsShown={false}
              mode="infinity"
              row={1}
              type="intertwined"
              page={0}
            >
              {posts.map((article: Article, id) => (
                <StyledArticleDesktopContainer key={id}>
                  <ArticleCardWrapper
                    article={article}
                    dataEventCategoryForTitle="Spotlight"
                    dataEventActionForTitle={`Slider Click ${id + 1}`}
                    dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    dataEventCategoryForCategory="Spotlight"
                    dataEventActionForCategory={`Slider Click ${id + 1}`}
                    dataEventLabelForCategory={`https://${domainLocales[locale]}${article.category.permalinkDecode}`}
                    dataEventCategoryForBanner="Spotlight"
                    dataEventActionForBanner={`Slider Click ${id + 1}`}
                    dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    type="author"
                    size="sm"
                    direction="vertical"
                    bannerImageWrapProps={
                      {
                        'data-event-category': 'Spotlight',
                        'data-event-action': `Click ${id + 1}`,
                        'data-event-label': `https://${domainLocales[locale]}${article.permalinkDecode}`,
                      } as any
                    }
                    text=""
                  />
                </StyledArticleDesktopContainer>
              ))}
            </ScrollList>
          </StyledScrollListContainer>
        </Container>
      ) : (
        <Container
          style={{
            backgroundColor: theme.colors.white,
            marginTop: 40,
            marginBottom: 64,
          }}
        >
          <StyledTitleContainer>
            <Heading tag="h3">{title}</Heading>
          </StyledTitleContainer>
          <StyledGeneralDesktopContainer>
            <StyledHeroContainer>
              {posts.slice(0, 1).map((article: Article, id) => (
                <StyledArticleContainer key={id}>
                  <ArticleCardWrapper
                    article={article}
                    dataEventCategoryForTitle="Top Article Title"
                    dataEventActionForTitle="Click 1"
                    dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    dataEventCategoryForCategory="Top Category Title"
                    dataEventActionForCategory="Click 1"
                    dataEventLabelForCategory={`https://${domainLocales[locale]}${article.category.permalinkDecode}`}
                    dataEventCategoryForBanner="Top Article Banner"
                    dataEventActionForBanner="Click 1"
                    dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                    type="author"
                    direction="vertical"
                    size="lg"
                  />
                </StyledArticleContainer>
              ))}
            </StyledHeroContainer>
            <div style={{ width: '100%' }}>
              <StyledSubHeroContainer>
                {posts.slice(1, 3).map((article: Article, id) => (
                  <StyledArticleDesktopContainer key={id}>
                    <ArticleCardWrapper
                      article={article}
                      dataEventCategoryForTitle="Top Article Title"
                      dataEventActionForTitle={`Click ${id + 2}`}
                      dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                      dataEventCategoryForCategory="Top Category Title"
                      dataEventActionForCategory={`Click ${id + 2}`}
                      dataEventLabelForCategory={`https://${domainLocales[locale]}${article.category.permalinkDecode}`}
                      dataEventCategoryForBanner="Top Article Banner"
                      dataEventActionForBanner={`Click ${id + 2}`}
                      dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                      type="author"
                      size="sm"
                      direction="vertical"
                      bannerImageWrapProps={
                        {
                          'data-event-category': 'Top Article Banner',
                          'data-event-action': `Click ${id + 2}`,
                          'data-event-label': `https://${domainLocales[locale]}${article.permalinkDecode}`,
                        } as any
                      }
                      text=""
                    />
                  </StyledArticleDesktopContainer>
                ))}
              </StyledSubHeroContainer>
              <StyledSubHeroContainer>
                {posts.slice(3, 5).map((article: Article, id) => (
                  <StyledArticleDesktopContainer key={id}>
                    <ArticleCardWrapper
                      article={article}
                      dataEventCategoryForTitle="Top Article Title"
                      dataEventActionForTitle={`Click ${id + 2}`}
                      dataEventLabelForTitle={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                      dataEventCategoryForCategory="Top Category Title"
                      dataEventActionForCategory={`Click ${id + 2}`}
                      dataEventLabelForCategory={`https://${domainLocales[locale]}${article.category.permalinkDecode}`}
                      dataEventCategoryForBanner="Top Article Banner"
                      dataEventActionForBanner={`Click ${id + 2}`}
                      dataEventLabelForBanner={`https://${domainLocales[locale]}${article.permalinkDecode}`}
                      type="author"
                      size="sm"
                      direction="vertical"
                      bannerImageWrapProps={
                        {
                          'data-event-category': 'Top Article Banner',
                          'data-event-action': `Click ${id + 2}`,
                          'data-event-label': `https://${domainLocales[locale]}${article.permalinkDecode}`,
                        } as any
                      }
                      text=""
                    />
                  </StyledArticleDesktopContainer>
                ))}
              </StyledSubHeroContainer>
            </div>
          </StyledGeneralDesktopContainer>
        </Container>
      )}
    </div>
  )
}

export { GeneralSection }
